import {Workbook} from 'igniteui-angular-excel';

export class ClsListaArchivos {
  NombreArchivo: string;
  TipoArchivo: string;
  Documento?: string;
  Extension?: string;
  TipoDocumento?: string;
  Neodata?: boolean;
  UltimaModificacion: string;
  Enlace: string;
  ContenidoArchivoFile?: File;
  ContenidoBase64?: string;
  Workbook?: Workbook;
}

export class ClsContenidoBucketStorage {
  NombreArchivo: string;
  NombreBucket: string;
  NombreDocumento?: string;
  Tipo?: string; // 'CH' | 'FASAR' | 'SC' | 'PI';
}

export class ClsArchivosEntrada {
  CH?: string;
  FASAR?: string;
  SC?: string;
  PI?: string;
}
